module.exports = __webpack_public_path__ + "img/bat.d3792043.png";